import { Component, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-massachusetts-review-one',
  templateUrl: './massachusetts-review-one.component.html',
  styleUrls: ['./massachusetts-review-one.component.scss']
})
export class MassachusettsReviewOneComponent {
  @Output() action: EventEmitter<void>;

  constructor() { 
    this.action = new EventEmitter<void>();
  }

  submit(): void {
    this.action.next();
  }
}
